import * as React from 'react';
import { AnalyticsStore } from 'bernie-core';

import { UitkCarousel } from 'uitk-react-carousel';
import { useStores } from 'utility/hooks';

import { FareTypeCard } from '.';
import { FlightsJourneyFare } from 'types/shared/flights-journey-fare';
import { AnalyticsType } from 'types/shared';

interface FareTypesProps {
  fareTypes: FlightsJourneyFare[];
  onFareTypeSelect: (index: number) => void;
  scrollAnalytics: AnalyticsType;
}

export const FareTypesCarousel = ({ fareTypes, onFareTypeSelect, scrollAnalytics }: FareTypesProps) => {
  const [isExpanded, setExpanded] = React.useState(false);
  const { analytics } = useStores();

  const setupTracker = (analytics: AnalyticsType, analyticsStore: AnalyticsStore) => {
    const { linkName, rfrr } = analytics;
    const callback = (_rfrr, _linkName) => {
      analyticsStore.trackEvent(_rfrr, _linkName, null);
    };

    return {
      callback,
      description: linkName,
      id: rfrr
    };
  };
  const analyticsTrack = setupTracker(scrollAnalytics, analytics);
  const carouselProps = {
    analytics: analyticsTrack,
    carouselName: 'UpsellCarousel',
    itemsVisible: {
      lg: 3,
      md: 2,
      sm: 1
    },
    pageBy: 1,
    peekWidth: {
      lg: 90,
      md: 40,
      sm: 40
    }
  };

  return (
    <UitkCarousel
      {...carouselProps}
      buttonText={{
        // TODO: return text from BEX-API
        nextButton: 'Next item',
        prevButton: 'Previous item'
      }}
      className="all-t-margin-six"
      wrapItems={false}
    >
      {fareTypes.map((fare: FlightsJourneyFare, index: number) => (
        <FareTypeCard
          key={index}
          fare={fare}
          index={index}
          onFareTypeSelect={onFareTypeSelect}
          isExpanded={isExpanded}
          setExpanded={setExpanded}
        />
      ))}
    </UitkCarousel>
  );
};
